<template>
  <div
    style="
      background-color: #efeeee !important;
          display: flex
;
    justify-content: center;
    "
  >
    <div class="mt-5 pb-5">
      <div >
        <VCard class="overallcard">
          <VForm v-model="valid" @submit.prevent="trackIdSend()">
            <VRow class="searchBtn">
              <VCol cols="12" md="12" sm="12">
                <h3>Enter your tracking number</h3>
              </VCol>

              <VCol cols="12" md="8" sm="8">
                <!-- <AppTextField
                v-model="consignmentNumber"
                label="CONSIGNMENT NUMBER"
                type="text"
                required
                :rules="validation"
              /> -->
                <label>CONSIGNMENT NUMBER</label>
                <v-text-field
                  class="login-form"
                  v-model="consignmentNumber"
                  required
                  type="text"
                  :rules="validation"
                  variant="outlined"
                >
                </v-text-field>
              </VCol>

              <VCol cols="12" md="4" sm="4" class="d-flex align-center">
                <VBtn color="#ed1c24" class="trackbtn" type="submit">
                  SEARCH
                </VBtn>
              </VCol>
            </VRow>
          </VForm>
        </VCard>
      </div>

      <div class="mt-3" v-if="responseTrackingData.length>0">
        
        <div class="row mt-2" >
          

<v-card >
  <v-card-title class="headline font-weight-bold">
    Parcel Tracking Details - {{ responseTrackingData[0]?.awb_number }}
  </v-card-title>

  <v-card-text>
    <v-divider class="my-4"></v-divider>

    <!-- Timeline -->
    <div>
      <!-- <h3 class="subtitle-1 font-weight-bold mb-3">Tracking Timeline</h3> -->

      <v-timeline dense>
        <v-timeline-item
          v-for="(data, index) in responseTrackingData"
          :key="index"
          :color="data.status_name === 'Delivered' ? 'green' : 'blue'"
        >
          <template v-slot:opposite>
            {{data.date}}
          </template>

          <v-card class="pa-3" outlined>
            <h4 class="subtitle-2 font-weight-bold mb-1">
              {{ data.status_name }}
            </h4>
            <p class="mb-1">From Hub Name: {{ data.from_hub_name }}</p>
            <p class="mb-1">From: {{ data.from_hub }}</p>
            <p class="mb-1">To Hub Name: {{ data.to_hub_name }}</p>
            <p class="mb-1">To: {{ data.to_hub }}</p>
            <p>{{ data.parcel_description }}</p>
          </v-card>
        </v-timeline-item>
      </v-timeline>
    </div>
  </v-card-text>

  <v-card-actions>
    <v-spacer></v-spacer>
  </v-card-actions>
</v-card>

      


<!-- <div class="row align-center mt-1 d-none">
  <div class="col-md-3">
<div class="title">
  {{ data.from_hub_name }}
</div>
<div class="title">
{{ data.from_hub }}
</div>
  </div>
  <div class="col-md-2">
<div class="title">{{ deliveryDate(data.date)}}</div>
  </div>
   <div class="col-md-3">
<div class="title">
  {{ data.to_hub_name }}
</div>
<div class="title">
{{ data.to_hub }}
</div>
  </div>
   <div class="col-md-2">
<div class="title">{{ data.status_name}}</div>
  </div>
   <div class="col-md-2">
   
 <div class="title">{{ data.awb_number}}</div>

  </div>


</div> -->
          

        </div>

      </div>
    </div>
  </div>
 <div v-if="pageLoader">
  <pageLoader ></pageLoader>
</div>
<v-dialog v-model="getEmailRes" persistent max-width="500">
  <v-card class="p-1 text-center"  >
    <div class="text-right">
      <v-icon
        color="red"
        @click="getEmailRes = false"
        class="cursor-pointer"
      >
        mdi-close-circle
      </v-icon>
    </div>

    <div class=" mt-1 p-3">
      <h5>{{ msgError }}</h5>
      
    </div>
  </v-card>
</v-dialog>

</template>

<script>
import axios from "axios";
import moment from "moment"
import pageLoader from "@/components/pageLoader.vue"
export default {
   components: {
    pageLoader
   },
  data() {
    return {
      tab: null,
      pageLoader:true,
      getEmailRes:false,

      msgError:'',
      consignmentNumber: "",
      responseTrackingData: [],
      overallResponse: "",
      endpoint:"",
      dataLoader: false,
      validation: [
        (v) => !!v || "Please enter a valid input",
        (v) => /^[0-9]*$/.test(v) || "Only numeric values are allowed",
      ],
    };
  },
  methods: {
    trackIdSend(){
 if(this.consignmentNumber)
      this.$router.push({
                    path: "/trackingData",
                    query: { shipping_id:this.consignmentNumber},
                  });
                  setTimeout(()=>{
                    window.location.reload();
                  },500)

    },
    getYear() {
      let currentdate = new Date();

      return currentdate.getFullYear();
    },
    deliveryDate(value){
return moment(value).format('DD-MM-YYYY')
    },

    async trackForm() {
      this.dataLoader = true;
   
 try 
{
 const responce= await axios.get(`https://xportal.skyrouteexpress.com/api/trackById?id=${this.consignmentNumber}`) 
  console.log(responce,'responce')
      this.pageLoader=false
  if(responce?.data?.status){

this.responseTrackingData=responce?.data?.parcel_track
  }
  else{
    this.msgError=responce?.data?.message
    this.getEmailRes=true
  }
console.log(this.responseTrackingData,'responseTrackingData')
}
catch(e){
  console.log(e,'error')
}

    },
  },

  created() {
    this.endpoint=localStorage.getItem("endpoint")
    if (this.$route.query.shipping_id) {
      this.consignmentNumber = this.$route.query.shipping_id;
      this.trackForm();
    }
  },
};
</script>

<style scoped>
.consignmentCard {
  margin-block: 50px;
  margin-block-end: 50px !important;
}
.tracking-card {
  border-radius: 16px;
  background: #fff;
}
.title{
  font-size: 14px;
    font-weight: 500;
}
.truncate-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
  display: inline-block;
}
.overallcard {
  padding: 25px !important;
  border-radius: 6px;
  background-color: white !important;
  box-shadow: 2px 3px 5px rgba(0, 0, 0, 20%);
  inline-size: 100%;
}

.trackingOverallCard {
  padding: 35px !important;
  border-radius: 8px;
  inline-size: 100%;
}

.v-label {
  font-size: 17px !important;
  font-weight: 900;
}

.trackbtn {
  /* margin-block-start:25px; */
  padding-block: 10px;
  padding-inline: 30px;
}

.v-table {
  color: black !important;
}

.v-btn__content {
  color: white !important;
}
>>>.v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
    border: none !important;
   background: none !important; 

}

.searchBtn label {
  font-weight: 600;
}

>>> .login-form .v-field {
  height: 42px;
}
>>> .login-form .v-field__input {
  padding-top: 0;
}
@media screen and (max-width:660px) {
.overallcard {
  padding: 25px !important;
  border-radius: 6px;
  background-color: white !important;
  box-shadow: 2px 3px 5px rgba(0, 0, 0, 20%);
  inline-size: 100%;
}

.trackingOverallCard {
  padding: 35px !important;
  border-radius: 8px;
  inline-size: 100%;
}
}
</style>
